import { getBreadcrumbs } from "react-breadcrumbs-light";
import { Link, withRouter } from "react-router-dom";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const CustomCrumbs = () => {
	const { t } = useTranslation("common");
	const isTourist = useSelector((state) =>
		Boolean(state?.BalanceReducer?.payloadAfterLogIn?.isTourist),
	);

	const homeLabel = t(isTourist ? "homeTourist" : "home");
	// Get current breadcrumbs
	const routes = [
		{ title: homeLabel, link: "/" },
		{ link: "/packages", title: t("packages") },
		{ link: "/sms-language", title: t("sms-lang") },
		{ link: "/payment", title: "Payment" },
	];

	const crumbs = getBreadcrumbs(routes, window.location.pathname);

	// Render
	return (
		<div className="wrapper">
			<div className="row">
				<div className="col-xs-12 col-md-11 flexRow alignCenter">
					<ul className="breadcrumb">
						{crumbs.map((item, i, arr) =>
							i !== arr.length - 1 ? (
								<Fragment key={i}>
									<li
										className={
											item.link === window.location.pathname ? "active" : ""
										}
									>
										<Link to={item.link}>{homeLabel}</Link>
									</li>
								</Fragment>
							) : (
								<li
									className={
										item.link === window.location.pathname ? "active" : ""
									}
									key={i}
								>
									{window.location.pathname === "/" ? homeLabel : item.title}
								</li>
							),
						)}
					</ul>
				</div>
			</div>
		</div>
	);
};

export const RoutedCustomCrumbs = withRouter(CustomCrumbs);
